module.exports = __webpack_public_path__ + "static/img/activity_gzh_qr.51cb0dc9.png";